import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Panel } from "@/components/PageHeader";
import { Pick } from "@/components/event-setup/BasicsSection";
import { shortId } from "@/lib/api";

const PLATFORMS = ["Facebook", "X", "Instagram", "LinkedIn", "YouTube", "TikTok", "WhatsApp", "Website"];

export const LinkListEditor = ({ title, items, onChange, kind, testId }) => {
  const social = kind === "social";
  const update = (id, patch) => onChange(items.map((i) => (i.id === id ? { ...i, ...patch } : i)));
  const add = () => onChange([...items, social ? { id: shortId(), platform: "Facebook", url: "https://" } : { id: shortId(), label: "", url: "https://" }]);
  return (
    <Panel title={title} testId={testId}>
      <div className="space-y-2">
        {items.map((it, i) => (
          <div key={it.id} className="grid grid-cols-1 sm:grid-cols-[200px_1fr_40px] gap-2 items-center">
            {social
              ? <Pick value={it.platform} onChange={(v) => update(it.id, { platform: v })} options={PLATFORMS} testId={`${testId}-platform-${i}`} />
              : <Input value={it.label} onChange={(e) => update(it.id, { label: e.target.value })} placeholder="Name shown" data-testid={`${testId}-label-${i}`} />}
            <Input value={it.url} onChange={(e) => update(it.id, { url: e.target.value })} placeholder="https://..." className="font-mono text-xs" data-testid={`${testId}-url-${i}`} />
            <button type="button" onClick={() => onChange(items.filter((x) => x.id !== it.id))} className="w-10 h-10 grid place-items-center rounded-md text-gray-500 hover:text-[#E60000] hover:bg-[#FFF0F0]" data-testid={`${testId}-remove-${i}`}><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
        {!items.length && <p className="text-sm text-gray-500">Nothing added yet.</p>}
      </div>
      <button type="button" onClick={add} className="mt-3 text-xs font-semibold text-[#E60000] hover:underline inline-flex items-center gap-1" data-testid={`${testId}-add`}><Plus className="w-3.5 h-3.5" />Add {social ? "social link" : "link"}</button>
    </Panel>
  );
};
